import {AnimationBaseController, GameApiBase, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {GameModel} from "./Models/GameModel";
import {GameController} from "./GameController";
import {GameLogic} from "./Logic/GameLogic";
import {AnimationContents} from "./Controllers/AnimationContents";
import {Field3DController} from "./Controllers/Field/Field3DController";
import { PlayerController } from "./Controllers/Player/PlayerController";
import { StickController } from "./Controllers/Player/StickController";
import { CameraConstants } from "./Constants/CameraConstants";
import { AIPlayerController } from "./Controllers/Player/AIPlayerController";
import { PlayerTurnConstant } from "./Constants/PlayerTurnConstant";
import { GameEventsConstants } from "./Constants/GameEventsConstants";
import { GrassController } from "./Controllers/Field/GrassController";
import { MiniMapController } from "./Controllers/MiniMap/MiniMapController";

export interface IGameScreenControllerOptions
{
    onQuit: () => void;
}

export class GameScreenController extends AnimationBaseController {
    $model: GameModel;


    public constructor(@Inject private _options:IGameScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("GameScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAMES_SCREEN_JSON,
            libraryName: "root",
            childControllers: {
                GameController:{
                    instanceName: "game",
                    view: GameController,
                    model: this.$model
                },
                Field3DController:{
                    view: Field3DController,
                    model: this.$model
                },
                GrassController: {
                    view: GrassController,
                    model: this.$model
                },
                MiniMapController: {
                    view: MiniMapController,
                    model: this.$model
                },
                // DebugPanelController: {
                //     view: DebugPanelController,
                //     model: this.$model,
                // },
                StickController:{
                    view: StickController,
                    model: this.$model
                },

                PlayerControllerA: {
                    view: PlayerController,
                    model: this.$model.playerA
                },
                PlayerControllerB: {
                    view: AIPlayerController,
                    model: this.$model.playerB
                },
            },
            modelWatch: {
                cameraIndex: (cameraIndex: CameraConstants) =>{
                    this.$childControllers.get<PlayerController>('PlayerControllerA').updateByModel();
                },
                isGameReady: (ready: boolean) => {
                    this._gameReadyHandler();
                }
            },
            modelEvents: {
                [GameEventsConstants.hitEnd]: () => {
                    if (this.$model.isGameReady && this.$model.currentTurn === PlayerTurnConstant.B) {
                        const player = this.$childControllers.get<AIPlayerController>('PlayerControllerB');
                        player.run();
                    }
                }
            }
        };
    }
    private _gameReadyHandler() {
        if (this.$model.isGameReady) {
            const player = this.$childControllers.get<AIPlayerController>('PlayerControllerB');
            player.setKykkas(this.$model.kykkaItemsB);
            player.setFieldSize(this.$model.fieldSize);
            this.$childControllers.get<PlayerController>('PlayerControllerA').setFieldSize(this.$model.fieldSize);
            if (this.$model.playerB.active) {
                player.run();
            }
        }
    }

    protected async onInitialize() {
        this.gotoAndStop(0);
        this.display.scale.y = 1.02;
        this.$childControllers.get<Field3DController>("Field3DController").x = -160;

        this._gameReadyHandler();
    }

    protected onLandscape(): void {
        this.gotoAndStop("landscape");
    }

    protected onPortrait(): void {
        this.gotoAndStop("portrait");
    }

    protected onUpdate(frameRate: number): void {
        this._gameLogic.update(frameRate);
    }

}

